const URLS = {
    OAUTH: '/oauth',
    GET_PROFILE: '/v4/manage/user/profile',
    GET_SUBSCRIPTIONS: '/v4/manage/user/subscriptions',
    GET_ACTIVE_SUBSCRIPTIONS: 'v4/manage/user/subscriptions/active',
    GET_INACTIVE_SUBSCRIPTIONS: 'v4/manage/user/subscriptions/inactive',
    GET_WHATS_HOT: '/v4/manage/ecal-world/whats-hot',
    GET_DISCOVER_PUBLISHERS: '/v4/manage/ecal-world/discover-publishers',
};

export default URLS;
